import { merchantApi } from '@/config/axios'

export interface ProductServiceGuaranteeVO {
  id?: number
  name: string
  iconUrl?: string
  sort?: number
  status?: number
}

/** 商家端：平台开启的服务保障精简列表（发品勾选） */
export const getSimpleServiceGuaranteeList = async () => {
  return await merchantApi.get<ProductServiceGuaranteeVO[]>({
    url: '/merchant-api/product/service-guarantee/list-all-simple'
  })
}
